const translations = {
  en: {
    "Your goal is live": "Your goal is live",
    "From now on I'm pushing this with you.":
      "From now on I'm pushing this with you.",
    "From now on I'm pushing this with you — %{var0}.":
      "From now on I'm pushing this with you — %{var0}.",
    "Got it": "Got it",
  },
  "zh-tw": {
    "Your goal is live": "你的目標已啟動",
    "From now on I'm pushing this with you.": "接下來我會和你一起推進。",
    "From now on I'm pushing this with you — %{var0}.":
      "接下來我會和你一起推進——%{var0}。",
    "Got it": "知道了",
  },
} as const;

export default translations;
